module.exports = __webpack_public_path__ + "img/Risk_Rate_v1_24@2x.7562e76f.png";